import type { ChaliceStore } from '../types';

export const selectZoneFeatures = (state: ChaliceStore) =>
  state.appConfig.zoneFeatures;
